import { TFunction } from "i18next";
import { EPARTY_STATUS } from "../../../enums";

export const GET_PARTY_STATUSES = (t: TFunction<"translation", undefined>) => ({
  [EPARTY_STATUS.INVITED]: {
    color: "#F8F9FB",
    textColor: "#555B6A",
    title: t("lbl_pending_join"),
  },
  [EPARTY_STATUS.JOINED]: {
    color: "#EBF4FF",
    textColor: "#0D44AD",
    title: t("active_client"),
  },
  [EPARTY_STATUS.REJECTED_INVITE]: {
    color: "#eb4c430f",
    textColor: "#eb4c43",
    title: t("lbl_invitation_rejected"),
  },
  [EPARTY_STATUS.WAITING_FOR_PAYMENT]: {
    color: "#FFFAEB",
    textColor: "#FFC107",
    title: t("lbl_pending_payment"),
  },
  [EPARTY_STATUS.PAID]: {
    color: "#F0FAF3",
    textColor: "#3ECC85",
    title: t("lbl_payment_done"),
  },
  [EPARTY_STATUS.ESCALATED]: {
    color: "#eb4c430f",
    textColor: "#eb4c43",
    title: t("lbl_escalated"),
  },
  [EPARTY_STATUS.PAYMENT_REJECTED]: {
    color: "#eb4c430f",
    textColor: "#eb4c43",
    title: t("lbl_payment_rejected"),
  },
  [EPARTY_STATUS.WAITING_FOR_DELIVERY]: {
    color: "#F0FAF3",
    textColor: "#3ECC85",
    title: t("lbl_payment_done"),
  },
  [EPARTY_STATUS.ITEM_ACCEPTED]: {
    color: "#F0FAF3",
    textColor: "#3ECC85",
    title: t("lbl_delivery_confirmed"),
  },
  [EPARTY_STATUS.ITEM_DELIVERED]: {
    color: "#F0FAF3",
    textColor: "#3ECC85",
    title: t("lbl_delivery_confirmed"),
  },
  [EPARTY_STATUS.PAYMENT_PENDING_APPROVAL]: {
    color: "#FFFAEB",
    textColor: "#FFC107",
    title: t("lbl_pending_bank_transfer_confirmation"),
  },
  [EPARTY_STATUS.WAITING_FOR_RELEASE]: {
    color: "#EBF4FF",
    textColor: "#0D44AD",
    title: t("lbl_money_being_transferred"),
  },
  [EPARTY_STATUS.RELEASED]: {
    color: "#F0FAF3",
    textColor: "#3ECC85",
    title: t("lbl_money_transferred"),
  },
  [EPARTY_STATUS.AVAILABLE_BALANCE]: {
    color: "#F0FAF3",
    textColor: "#3ECC85",
    title: t("lbl_added_to_wallet"),
  },
  [EPARTY_STATUS.REFUNDED]: {
    color: "#F0FAF3",
    textColor: "#3ECC85",
    title: t("lbl_money_transferred"),
  },
  [EPARTY_STATUS.ARBITRATOR_ACCEPT_ITEM]: {
    color: "#EBF4FF",
    textColor: "#0D44AD",
    title: t("lbl_arbitrator_accept_item"),
  },
  [EPARTY_STATUS.ARBITRATOR_REJECT_ITEM]: {
    color: "#eb4c430f",
    textColor: "#eb4c43",
    title: t("lbl_arbitrator_reject_item"),
  },
  [EPARTY_STATUS.ARBITRATOR_ACCEPT_DELIVERY]: {
    color: "#EBF4FF",
    textColor: "#0D44AD",
    title: t("lbl_arbitrator_accept_delivery"),
  },
  [EPARTY_STATUS.ARBITRATOR_REJECT_DELIVERY]: {
    color: "#eb4c430f",
    textColor: "#eb4c43",
    title: t("lbl_arbitrator_reject_delivery"),
  },
  [EPARTY_STATUS.ARBITRATOR_REFUNDED_CUSTOMER]: {
    color: "#283743",
    title: t("lbl_arbitrator_ended_for_buyer"),
  },
  // TODO: What is the mapping for this?
  ["completed"]: {
    color: "#44C16E",
    title: t("lbl_money_transferred_and_contract_done"),
  },
  ["null"]: {
    color: "#F8F9FB",
    textColor: "#555B6A",
    title: t("lbl_pending_join"),
  },
});
